import { loadable } from '@change-corgi/core-react/loadable';

import type { AppRoute } from '#src/shared/routes';

import { SOCIAL_STARTER_ROUTE_ID } from '#src/app/pages/psf/promoteOrShare/shared/consts';
import { createRoutes, Loading } from '#src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	...createRoutes(
		{
			component: loadable(async () => import(/* webpackChunkName: "pages/psf-promoteOrShare" */ './index'), {
				exportName: 'PsfPromoteOrShare',
				fallback: Loading,
			}),
			ssr: {
				// switch this to true to enable SSR
				enabled: true,
				seo: false,
				// FIXME: temporary solution to force external navigation (resulting in session update)
				// when navigating to and from this page, to handle sign resulting in an identified state in non-GDPR countries
				isolated: true,
			},
		},
		[
			{
				id: 'psf-promote-or-share',
				path: '/p/:slug/psf/promote_or_share',
				frame: false,
			},
			{
				id: SOCIAL_STARTER_ROUTE_ID,
				path: '/p/:slug/psf/social_starter',
				frame: false,
			},
		],
	),
];
